'use client'
import { jsx } from 'react/jsx-runtime';
import { SignInWithEmailIcon } from '@dynamic-labs/iconic';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { isEmailOTPWalletConnector, isSocialWalletConnector, isAccountAbstractionConnector, isEmbeddedConnector } from '@dynamic-labs/wallet-connector-core';
import { useAccessDeniedContext } from '../../context/AccessDeniedContext/AccessDeniedContext.js';
import 'react';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../shared/logger.js';
import '../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgEmbeddedWalletIcon } from '../../shared/assets/embedded-wallet-icon.js';
import { ReactComponent as SvgSmartWallet } from '../../shared/assets/smart-wallet.js';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import '../../store/state/loadingAndLifecycle.js';
import '../../shared/consts/index.js';
import '../../events/dynamicEvents.js';
import '../../../../_virtual/_tslib.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import { getReferencedAccount } from '../../utils/functions/getReferencedAccount/getReferencedAccount.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../config/ApiEndpoint.js';
import '../../store/state/user/user.js';
import '../../locale/locale.js';
import '../../store/state/projectSettings/projectSettings.js';
import '../../context/AccountExistsContext/AccountExistsContext.js';
import '../../context/UserWalletsContext/UserWalletsContext.js';
import '../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import { useWalletContext } from '../../context/WalletContext/WalletContext.js';
import '../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import { useFindSocialIcon } from '../../utils/hooks/useFindSocialIcon/useFindSocialIcon.js';
import '../../context/ThemeContext/ThemeContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '@dynamic-labs/types';
import '../../context/LoadingContext/LoadingContext.js';
import 'yup';
import '../../context/MockContext/MockContext.js';
import '../../views/CollectUserDataView/useFields.js';
import '../../context/FieldsStateContext/FieldsStateContext.js';
import '../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../store/state/environmentId.js';
import '../../store/state/walletConnectorOptions.js';
import 'react-i18next';
import '../Accordion/components/AccordionItem/AccordionItem.js';
import '../Alert/Alert.js';
import '../ShadowDOM/ShadowDOM.js';
import '../IconButton/IconButton.js';
import '../InlineWidget/InlineWidget.js';
import '../Input/Input.js';
import '../IsBrowser/IsBrowser.js';
import '../MenuList/Dropdown/Dropdown.js';
import '../Transition/ZoomTransition/ZoomTransition.js';
import '../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../Transition/OpacityTransition/OpacityTransition.js';
import '../OverlayCard/OverlayCardTarget/OverlayCardTarget.js';
import '../PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../Popper/Popper/Popper.js';
import '../Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import { WalletIconWithNetwork } from '../../widgets/DynamicWidget/components/WalletIconWithNetwork/WalletIconWithNetwork.js';
import 'formik';
import '../../context/FooterAnimationContext/index.js';
import '../../context/WalletGroupContext/WalletGroupContext.js';
import '../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../context/PasskeyContext/PasskeyContext.js';
import '../../store/state/sendBalances.js';
import '../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'bs58';
import '../../views/TransactionConfirmationView/helpers/transactionErrorMessage.js';
import '../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../index.js';
import '../../store/state/tokenBalances.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useDynamicContext/useInternalDynamicContext.js';

const getWalletIcon = ({ findSocialIcon, wallet, user, }) => {
    if (isEmailOTPWalletConnector(wallet.connector)) {
        return SignInWithEmailIcon;
    }
    if (isSocialWalletConnector(wallet.connector)) {
        const socialAccountDataForWallet = getReferencedAccount(user, wallet.id);
        if (!socialAccountDataForWallet ||
            !socialAccountDataForWallet.oauthProvider) {
            return SignInWithEmailIcon;
        }
        const { oauthProvider } = socialAccountDataForWallet;
        try {
            const MagicSocialWalletIcon = findSocialIcon(oauthProvider);
            return MagicSocialWalletIcon;
        }
        catch (err) {
            logger.error(err);
        }
    }
    if (isAccountAbstractionConnector(wallet.connector)) {
        return SvgSmartWallet;
    }
    if (isEmbeddedConnector(wallet.connector)) {
        return SvgEmbeddedWalletIcon;
    }
    return null;
};
const AuthProviderIcon = ({ iconSize = 64, showNetworkIcon = false, wallet, }) => {
    const { primaryWallet, selectedWalletConnector, user, userWithMissingInfo } = useInternalDynamicContext();
    const { deniedOauthProvider, deniedAddress } = useAccessDeniedContext();
    const { isLoadingEmbeddedWallet } = useWalletContext();
    const findSocialIcon = useFindSocialIcon();
    if (deniedOauthProvider) {
        const MagicSocialWalletIcon = findSocialIcon(deniedOauthProvider);
        if (!MagicSocialWalletIcon) {
            return null;
        }
        return (jsx(MagicSocialWalletIcon, { style: {
                height: pixelToRem(iconSize),
                width: pixelToRem(iconSize),
            } }));
    }
    // it means that user tried to login with actual wallet and no magic social and failed to go through the access list
    if (deniedAddress) {
        return (jsx(WalletIcon, { walletKey: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key, style: { height: pixelToRem(iconSize), width: pixelToRem(iconSize) } }));
    }
    const walletForIcon = wallet ? wallet : primaryWallet;
    if (!walletForIcon) {
        if (isLoadingEmbeddedWallet) {
            return (jsx(WalletIconWithNetwork, { iconSize: iconSize, Icon: SvgEmbeddedWalletIcon, chainName: 'EVM', showNetwork: false }));
        }
        return null;
    }
    const Icon = getWalletIcon({
        findSocialIcon,
        user: user !== null && user !== void 0 ? user : userWithMissingInfo,
        wallet: walletForIcon,
    });
    return (jsx(WalletIconWithNetwork, { iconSize: iconSize, Icon: Icon !== null && Icon !== void 0 ? Icon : null, chainName: walletForIcon.chain, showNetwork: showNetworkIcon, walletKey: walletForIcon.key }));
};

export { AuthProviderIcon };
